<template>
  <div
      class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 relative group h-80"
  >
    <!-- Image Section -->
    <div class="relative h-48 w-full overflow-hidden">
      <img
          :src="image"
          :alt="title"
          class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <!-- Description Overlay (Hidden by default, appears on hover) -->
      <div
          class="absolute inset-0 bg-black bg-opacity-70 text-white p-4 flex items-center justify-center transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out"
      >
        <p class="text-sm text-center">{{ description }}</p>
      </div>
    </div>
    <!-- Title and Link Section -->
    <div class="p-4 flex flex-col justify-between h-32">
      <h3 class="text-lg font-bold text-blue-900 text-center">{{ title }}</h3>
      <router-link
          :to="link"
          class="text-yellow-600 font-medium hover:text-yellow-700 flex items-center justify-center text-sm"
      >
        Learn more
        <svg
            class="w-4 h-4 ml-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
          ></path>
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import electrical1 from '@/assets/images/electrical-1.jpg';
import electrical2 from '@/assets/images/electrical-3.jpg';
import electrical3 from '@/assets/images/electrical-4.jpg';
import electrical4 from '@/assets/images/electrical-5.jpg';
import electrical5 from '@/assets/images/electrical-6.jpg';

const images = [electrical1, electrical2, electrical3, electrical4, electrical5];

const props = defineProps({
  title: String,
  description: String,
  link: String,
  index: Number, // To map the correct image
});

const image = computed(() => images[props.index]);
</script>